import { applyMiddleware, createStore, combineReducers, compose } from 'redux';
import createHistory from 'history/createBrowserHistory';
import { routerReducer, routerMiddleware } from 'react-router-redux';
import thunk from 'redux-thunk';
import { Network } from 'ui-utilities';

import { entities } from './reducers/entities';
import { auth } from './reducers/auth';
import { search } from './reducers/search';
import { customer } from './reducers/customer';
import { merchant } from './reducers/merchant';
import { plan } from './reducers/plan';
import { flag } from './reducers/flag';
import { social } from './reducers/social';
import { systemMessage } from './reducers/systemMessage';

export const reducers = combineReducers({
  entities,
  auth,
  search,
  customer,
  merchant,
  plan,
  flag,
  social,
  systemMessage,
  router: routerReducer
});

const composeEnhancers = (process.env.NODE_ENV !== 'production' && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__) || compose;

export const history = createHistory();
const middlewares = [routerMiddleware(history), thunk];
export const middleware = applyMiddleware(...middlewares);

export const configureStore = () => {
  const s = createStore(reducers, composeEnhancers(middleware));

  if (module.hot && process.env.NODE_ENV !== 'production') {
    // Enable Webpack hot module replacement for reducers
    module.hot.accept(reducers, () => {
      const nextRootReducer = reducers;
      s.replaceReducer(nextRootReducer);
    })
  }

  return s;
}

export const store = configureStore();
export const api = () => Network(store);



// WEBPACK FOOTER //
// ./src/store.js